import { mediaQuery, minBreakpoints, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { nothsTheme } from 'src/styles/noths.theme';

const { fonts } = theme;
const { color: nothsColor } = nothsTheme;

export const CardLink = css`
  display: block;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
  text-decoration: none;
  outline: none;
  margin: 0 5px 10px;
  color: ${nothsColor.primaryDark};

  :hover {
    opacity: 0.9;
    text-decoration: underline;
  }

  > img {
    border-radius: 0;
  }

  &[data-plain-style='true'] {
    border: 0;
    > img {
      border-radius: 3px;
    }
  }
  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      margin: 0 10px;

      a:hover {
        opacity: 1;
      }
    `,
  )};
`;

export const CardTitle = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  color: ${nothsColor.primaryDark};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  padding: 0 10px;
  margin: 0;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-transform: uppercase;
  line-height: normal;

  &[data-plain-style='true'] {
    display: block;
    height: auto;
    padding: 10px 0;
    text-align: left;
    font-size: 16px;
    text-transform: lowercase;
  }

  ${mediaQuery(
    { min: minBreakpoints.MEDIUM },
    css`
      font-size: 16px;
      height: 60px;

      &[data-plain-style='true'] {
        height: auto;
      }
    `,
  )};
`;
